import React from 'react';
import { styled, keyframes } from '@mui/material/styles';
import Box from '@mui/material/Box';
import beforepayLogo from '@/assets/beforepay-logo.png'; 

export const Loader: React.FC = () => {
  return (
    <LoaderWrapper>
      <LogoContainer>
        <Logo src={beforepayLogo} alt="Loading..." />
      </LogoContainer>
    </LoaderWrapper>
  );
};

const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.08);
    opacity: 0.95;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const LoaderWrapper = styled(Box)(() => ({ 
  height: '100vh',
  width: '100vw',
  backgroundColor: "#EAECF0",
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

const LogoContainer = styled(Box)(() => ({
  height: 80,
  width: 80,
  borderRadius: '50%',
  backgroundColor: 'rgba(234, 234, 255, 0.8)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  animation: `${pulse} 1.1s ease-in-out infinite`,
  opacity: '0.1'
}));

// Animated logo inside circle
const Logo = styled('img')(() => ({
  animation: `${pulse} 1.1s ease-in-out infinite`,
}));

